var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 160,
    viewBox: "0 0 161 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80.5,
    cy: 76.8,
    r: 56,
    fill: "#FEF6F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.5 54.3999L131.7 54.3999",
    stroke: "#F7BA97",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 94.3999L31.7 94.3999",
    stroke: "#F7BA97",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.3 60L130.1 60",
    stroke: "#F7BA97",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2998 100L30.0998 100",
    stroke: "#F7BA97",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M137.3 54.3999H140.5",
    stroke: "#F7BA97",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M112.035 54.7193C124.229 72.1354 119.997 96.1397 102.581 108.335C85.1647 120.529 61.1603 116.297 48.9655 98.8808C36.7706 81.4647 41.0032 57.4604 58.4193 45.2655C75.8353 33.0707 99.8397 37.3033 112.035 54.7193Z",
    stroke: "#FBE1E8",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105.482 59.3075C115.143 73.1047 111.79 92.1211 97.9925 101.782C84.1954 111.443 65.179 108.09 55.5181 94.2926C45.8573 80.4954 49.2104 61.479 63.0075 51.8182C76.8046 42.1573 95.821 45.5104 105.482 59.3075Z",
    fill: "white",
    stroke: "#E9688A",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.735 57.1421C62.1035 60.3851 58.9677 64.9678 57.4844 69.9999",
    stroke: "#FBE1E8",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0996 81.3333L76.5996 88L90.8996 72",
    stroke: "#E9688A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessSmall);
export default __webpack_public_path__ + "static/media/successSmall.ef583fe8b43f02b87c1db90a331f44b7.svg";
export { ForwardRef as ReactComponent };